import m from "mithril";
const Link = m.route.Link;
export default {
    view() {
        return (m("section", { class: "error" },
            m("div", { class: "alert alert--danger mv3 pulse animated" }, "Bei der Abfrage einiger Daten ist wohl ein Fehler aufgetreten. Bitte versuche es sp\u00E4ter erneut oder melde es bei der IT."),
            m("div", null,
                m(Link, { href: "/", title: "zur\u00FCck", class: "btn btn--link" },
                    m("i", { class: "fas fa-arrow-left mr1" }),
                    " Zur\u00FCck"))));
    },
};
